import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { BOLD_FONT_FAMILY } from '../constants/constants';
import { DevToolsCountdownTimerPage } from './devToolsCountdownTimerPage';
import { DevToolsMiscPage } from './devToolsMiscPage';
import { DevToolsRandomAvatarsPage } from './devToolsRandomAvatarsPage';
import { DevToolsStylingShowcasePage } from './devToolsStylingShowcasePage';
import { DevToolsTableGraphicsPage } from './devToolsTableGraphicsPage';
const ALL_DEV_TOOLS_PAGE_PROPERTIES = {
    'random-avatars': {
        name: 'Random Avatars',
        render: () => _jsx(DevToolsRandomAvatarsPage, {})
    },
    'table-graphics': {
        name: 'Table Graphics',
        render: () => _jsx(DevToolsTableGraphicsPage, {})
    },
    'styling-showcase': {
        name: 'Styling Showcase',
        render: () => _jsx(DevToolsStylingShowcasePage, {})
    },
    'countdown-timer': {
        name: 'Countdown Timer',
        render: () => _jsx(DevToolsCountdownTimerPage, {})
    },
    misc: {
        name: 'Misc',
        render: () => _jsx(DevToolsMiscPage, {})
    }
};
export const BUTTON_CONTAINER_CSS = css `
  padding: 5px;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  gap: 5px;
`;
const DevToolsContents = () => {
    const [devToolsPageType, setDevToolsPageType] = useState();
    if (!devToolsPageType) {
        return (_jsx("div", { css: BUTTON_CONTAINER_CSS, children: Object.entries(ALL_DEV_TOOLS_PAGE_PROPERTIES).map(([devToolsPageType, devToolsPageProperties]) => {
                const { name } = devToolsPageProperties;
                return (_jsx(Button, { variant: 'contained', onClick: () => setDevToolsPageType(devToolsPageType), children: name }, devToolsPageType));
            }) }));
    }
    // render current dev tools page:
    const { render, name } = ALL_DEV_TOOLS_PAGE_PROPERTIES[devToolsPageType];
    return (_jsxs(_Fragment, { children: [_jsxs("div", { css: BUTTON_CONTAINER_CSS, children: [_jsx(Button, { variant: 'outlined', size: 'small', onClick: () => setDevToolsPageType(undefined), children: "Back" }), _jsx(Typography, { variant: 'h5', css: css `
            font-family: ${BOLD_FONT_FAMILY};
          `, children: name })] }), render()] }));
};
export default DevToolsContents;
